import { createSlice } from "@reduxjs/toolkit"
import { CustomerRepository, ListCustomer } from "../models/customer.model"
import { RootState } from "../app/store"

export const initialPaginationState = {
  page: 0,
  pageSize: 10,
}

export const customerInitialState: {
  customers: ListCustomer[]
  customersRepository: CustomerRepository[]
  pageInfo: {
    totalRowCount: number
  }
  loading: boolean
} = {
  customers: [],
  customersRepository: [],
  pageInfo: {
    totalRowCount: 0,
  },
  loading: false,
}

export type fetchCustomersPayloadType = {
  payload: {
    customer?: string
    status: string
    page: number
    pageSize: number
    sortBy?: string
    orderBy?: string
  }
}
export type fetchCustomersRepositoryPayloadType = {
  payload: {
    customer?: string
    page: number
    pageSize: number
    sortBy?: string
    orderBy?: string
    source?: string
    description?: string
  }
}

const customerSlice = createSlice({
  name: "customer",
  initialState: customerInitialState,
  reducers: {
    // action creators for saga flow
    fetchCustomersRequest: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      action: fetchCustomersPayloadType,
    ) => {
      state.loading = true
    },
    fetchCustomersSuccess: (
      state,
      {
        payload,
      }: { payload: { customers: ListCustomer[]; totalRowCount: number } },
    ) => {
      state.loading = false
      state.customers = payload.customers
      state.pageInfo.totalRowCount = payload.totalRowCount
    },
    fetchCustomersFailure: (state) => {
      state.loading = false
    },
    fetchCustomerRepositoryRequest: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      action: fetchCustomersRepositoryPayloadType,
    ) => {
      state.loading = true
    },
    fetchCustomerRepositorySuccess: (
      state,
      {
        payload,
      }: {
        payload: { customers: CustomerRepository[]; totalRowCount: number }
      },
    ) => {
      state.loading = false
      state.customersRepository = payload.customers
      state.pageInfo.totalRowCount = payload.totalRowCount
    },
    fetchCustomerRepositoryFailure: (state) => {
      state.loading = false
    },
  },
})

export const {
  fetchCustomersRequest,
  fetchCustomersSuccess,
  fetchCustomersFailure,
  fetchCustomerRepositoryRequest,
  fetchCustomerRepositorySuccess,
  fetchCustomerRepositoryFailure,
} = customerSlice.actions

export const selectCustomerState = (state: RootState) => state.customer

export default customerSlice.reducer
